import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { useQuickDuel } from '../context/QuickDuelContext';
import QuickDuel from '../components/duels/QuickDuel';
import QuickDuelQueue from '../components/duels/QuickDuelQueue';
import QueueStats from '../components/duels/QueueStats';
import DuelStats from '../components/duels/DuelStats';
import DuelRating from '../components/duels/DuelRating';
import MatchFoundModal from '../components/duels/MatchFoundModal';
import HrnbCard from '../components/controls/HrnbCard';
import '../css/pages/QuickDuelsPage.css';

/**
 * Страница быстрых дуэлей
 */
function QuickDuelsPage() {
    const navigate = useNavigate();
    const { currentUser } = useContext(UserContext);
    const { matchEvent, clearMatch, leaveQueue } = useQuickDuel();

    const handleAcceptMatch = () => {
        if (matchEvent) {
            navigate(`/quick-duels/${matchEvent.duelId}`);
            clearMatch();
        }
    };

    const handleDeclineMatch = async () => {
        try {
            await leaveQueue();
        } catch (err) {
            console.error('[QuickDuelsPage] Failed to leave queue after decline:', err);
        }
        clearMatch();
    };

    return (
        <div className="quick-duels-page">
            <div className="quick-duels-page__header">
                <h1 className="quick-duels-page__title">⚡ Быстрые дуэли</h1>
                <p className="quick-duels-page__subtitle">
                    Найди соперника для мгновенной дуэли
                </p>
            </div>

            {/* Основной компонент поиска */}
            <div className="quick-duels-page__main">
                <QuickDuelQueue />
            </div>

            {/* Статистика очереди */}
            <div className="quick-duels-page__queue-stats">
                <QueueStats />
            </div>

            {/* Дополнительная информация */}
            <div className="quick-duels-page__info-section">
                <div className="quick-duels-page__info-grid">
                    {/* Статистика игрока */}
                    {currentUser && (
                        <div className="quick-duels-page__stats">
                            <HrnbCard title="📊 Ваша статистика">
                                <DuelStats profileId={currentUser.id} />
                            </HrnbCard>
                        </div>
                    )}

                    {/* Рейтинг */}
                    <div className="quick-duels-page__rating">
                        <HrnbCard title="🏆 Топ игроков">
                            <DuelRating />
                        </HrnbCard>
                    </div>
                </div>
            </div>

            {/* Правила */}
            <div className="quick-duels-page__rules">
                <HrnbCard title="📜 Как это работает">
                    <div className="quick-duels-page__rules-list">
                        <div className="quick-duels-rule">
                            <span className="quick-duels-rule__icon">🎯</span>
                            <div className="quick-duels-rule__content">
                                <h4>Настройте параметры</h4>
                                <p>Выберите формат (1v1, 2v2, 3v3) и предпочтительный диапазон рейтинга соперника</p>
                            </div>
                        </div>
                        <div className="quick-duels-rule">
                            <span className="quick-duels-rule__icon">⏳</span>
                            <div className="quick-duels-rule__content">
                                <h4>Ожидайте в очереди</h4>
                                <p>Система автоматически подберёт подходящего соперника по вашим критериям</p>
                            </div>
                        </div>
                        <div className="quick-duels-rule">
                            <span className="quick-duels-rule__icon">⚔️</span>
                            <div className="quick-duels-rule__content">
                                <h4>Начните дуэль</h4>
                                <p>При нахождении матча вы получите уведомление — примите его, чтобы перейти на страницу дуэли с раундами, судьями и работами</p>
                            </div>
                        </div>
                        <div className="quick-duels-rule">
                            <span className="quick-duels-rule__icon">🔄</span>
                            <div className="quick-duels-rule__content">
                                <h4>Выйдите в любой момент</h4>
                                <p>Можно покинуть очередь поиска, если передумали играть</p>
                            </div>
                        </div>
                    </div>
                </HrnbCard>
            </div>

            {/* Модальное окно найденного матча */}
            <MatchFoundModal
                event={matchEvent}
                onAccept={handleAcceptMatch}
                onDecline={handleDeclineMatch}
            />
        </div>
    );
}

export default QuickDuelsPage;
